import { useEffect } from "react";
import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import FirstPart from "./FirstPart";
import SecondPart from "./SecondPart";

const WatchCourse = ({ 
  fetchCourse, 
  setLoader, 
  fetchModuleProgress, 
  course, 
  modules, 
  gl, 
  cl, 
  ct, 
  cd, 
  loader, 
  handleVideoEnd, 
  moduleIndex, 
  lessonIndex, 
  setLessonIndex, 
  setModuleIndex, 
  ac, 
  questions 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  useEffect(() => {
    console.log("moduleIndex", moduleIndex);
    console.log("lessonIndex", lessonIndex);
  }, []);

  return (
    <>
      {/* Header Section */}
      <Box 
        sx={{ 
          backgroundColor: '#f5e9d9', 
          p: { xs: 2, md: 3 }, 
          borderBottom: 1, 
          borderColor: 'divider' 
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <Typography 
              variant={isMobile ? "h6" : "h5"} 
              sx={{ 
                fontWeight: 'bold', 
                mb: isMobile ? 1 : 0 
              }}
            >
              {moduleIndex + 1}. {modules?.[moduleIndex]?.title}
            </Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography 
              variant={isMobile ? "h5" : "h4"} 
              sx={{ 
                fontWeight: 'bold', 
                textDecoration: 'underline',
                textAlign: { xs: 'left', md: 'left' }
              }}
            >
              {moduleIndex + 1}.{lessonIndex + 1} {modules?.[moduleIndex]?.lessons?.[lessonIndex]?.title}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Main Content Section */}
      <Box sx={{ p: { xs: 1, md: 0, lg: 0 } }}>
        <Grid container spacing={0}>
          {/* Sidebar - FirstPart */}
          <Grid 
            item 
            xs={12} 
            md={3} 
            lg={4}
            sx={{ 
              order: { xs: 2, md: 1 }, // Stack below on mobile
              position: { md: 'sticky' },
              top: 0,
              height: { md: 'fit-content' },
              maxHeight: { md: '100vh' },
              overflowY: { md: 'auto' },
              width: { lg: '30%' },
              maxWidth: { lg: '30%' }
            }}
          >
            <FirstPart 
              fetchModuleProgress={fetchModuleProgress} 
              course={course} 
              modules={modules} 
              module={moduleIndex} 
              lessonIndex={lessonIndex} 
              setLessonIndex={setLessonIndex} 
              setModuleIndex={setModuleIndex} 
              gl={gl} 
              ac={ac} 
            />
          </Grid>

          {/* Main Content - SecondPart */}
          <Grid 
            item 
            xs={12} 
            md={9} 
            lg={8}
            sx={{ 
              order: { xs: 1, md: 2 }, // On top on mobile
            }}
          >
            <SecondPart 
              fetchCourse={fetchCourse} 
              setLoader={setLoader} 
              module={modules?.[moduleIndex]} 
              lesson={modules?.[moduleIndex]?.lessons?.[lessonIndex]} 
              moduleId={modules?.[moduleIndex]?.id} 
              cl={cl} 
              ct={ct} 
              cd={cd} 
              loader={loader} 
              handleVideoEnd={handleVideoEnd} 
              questions={questions} 
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default WatchCourse;